import { useTranslation } from 'react-i18next';

import { Avatar, Button, Divider } from '@treezor/design-system';

import { useProfileContext } from '@/features/context/ProfileContext';
import { DeleteUser } from '@/features/user/components/DeleteUser';
import { SendForgotPassword } from '@/features/user/components/sendForgotPassword/SendForgotPassword';
import { useAccesControl } from '@/hooks/useAccessControl';
import { useAction } from '@/hooks/useAction';
import { featuresSlugs } from '@/features/roles/store/models/features.model';
import { useUserActions } from '@/features/user/hooks//useUserActions';
import { KycStatus } from '@/features/kyc/components/kyc-infos/KycStatus';
import { UserStatus } from '@/features/user/components/status/UserStatus';
import { useUserInfo } from '@/features/user/hooks/useUserInfo';
import { UserTypes } from '@/features/user/store/user.model';

export const ProfileHeader = () => {
  const { t } = useTranslation();

  const { user } = useProfileContext();
  const { hasAccessToFeature } = useAccesControl();
  const { displayActionFromConfig } = useAction();

  const { initial, name, status, userRole, userType } = useUserInfo(user);

  const { navigateToUser } = useUserActions();
  return (
    <div className="flex gap-6 pt-6">
      <div className="flex gap-4">
        <Avatar label={initial} color="blue" size="l" />

        <div className="flex flex-col gap-2">
          <div className="flex gap-3">
            <p className="typo-h6-bold text-primary items-center">{name}</p>
            {status && <UserStatus {...status} />}
          </div>
          <div className="flex gap-4 items-center">
            <span className="typo-body-regular-small text-tertiary">#{user?.userId}</span>
            <Divider direction="vertical" thickness="100" />
            <span className="typo-body-regular-small text-tertiary">
              {user.userTypeId === UserTypes.naturalPerson && userRole
                ? t(`pages.dashboard.users.physicalUserRole.${userRole}`)
                : userType}
            </span>
            <Divider direction="vertical" thickness="100" />
            <div className="flex gap-3 items-center">
              <span className="typo-body-regular-small text-tertiary">
                {t('pages.dashboard.users.table.kycStatus')}
              </span>
              <KycStatus user={user} />
            </div>
          </div>
          {!!user.userTag && (
            <div className="flex gap-3">
              <span className="typo-body-regular-small text-tertiary">
                {t('pages.currentProfiles.profile.informations.tag')}
              </span>
              <span className="typo-body-regular-small text-tertiary">{user.userTag}</span>
            </div>
          )}
        </div>
      </div>
      <div className="flex ml-auto gap-2">
        {hasAccessToFeature(featuresSlugs.DESACTIVATE_USER) &&
          displayActionFromConfig('deleteUser') &&
          user.userStatus !== 'CANCELED' && <DeleteUser />}
        {hasAccessToFeature(featuresSlugs.SEND_FORGOT_PASSWORD) && displayActionFromConfig('sendForgotPassword') && (
          <SendForgotPassword />
        )}
        {Boolean(user.parentUserId) && (
          <Button id="parent-page-btn" onClick={() => navigateToUser(user.parentUserId)}>
            {t('pages.currentProfiles.actionUser.parentUser')}
          </Button>
        )}
      </div>
    </div>
  );
};
